__turbopack_context__.v({
  "cta": "DRFWnW_cta",
  "description": "DRFWnW_description",
  "title": "DRFWnW_title",
  "titleAndLinkWrapper": "DRFWnW_titleAndLinkWrapper",
  "wrapper": "DRFWnW_wrapper",
});
